export function isCoinsubDomain() {
  return window.location.host.includes("coinsub.io");
}

export function formatTimer(seconds) {
  if (!seconds || seconds < 0 || typeof seconds !== 'number') {
    return "0:00";
  }

  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${sec.toString().padStart(2, '0')}`;
}

export { debugLog, debugError } from './debugLog';
export { syncCheckoutOverview } from './syncCheckoutOverview';
